<template>
  <button class="btn-cool-animated" @click="$emit('click')">
    <span class="circle1"></span>
    <span class="circle2"></span>
    <span class="circle3"></span>
    <span class="circle4"></span>
    <span class="circle5"></span>
    <span class="text">
      <slot></slot>
    </span>
  </button>
</template>

<script>
export default {
  name: 'AnimatedButton',
};
</script>

<style scoped>
.btn-cool-animated {
  position: relative;
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 600;
  color: #ffffff !important;
  background: var(--primary-color, #18d600);
  border: none;
  border-radius: 8px;
  cursor: pointer;
  overflow: hidden;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(24, 214, 0, 0.25);
}

.btn-cool-animated:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(24, 214, 0, 0.4);
}

.btn-cool-animated .text {
  position: relative;
  z-index: 2;
  display: inline-flex;
  align-items: center;
  color: #ffffff !important;
  gap: 8px;
}

.btn-cool-animated span:not(.text) {
  position: absolute;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  transition: all 0.6s ease;
}

.circle1 { width: 30px; height: 30px; top: -10px; left: -10px; }
.circle2 { width: 40px; height: 40px; bottom: -15px; right: -10px; }
.circle3 { width: 20px; height: 20px; top: 50%; left: 30%; }
.circle4 { width: 15px; height: 15px; bottom: 10%; left: 60%; }
.circle5 { width: 25px; height: 25px; top: -5px; right: 20%; }

.btn-cool-animated:hover span:not(.text) {
  transform: scale(2);
  opacity: 0;
}
</style>
